export default __webpack_public_path__ + "assets/cuisine-design-moderne-quebec.eef4f2cc.webp";